import React from 'react'
import {
  Slider,
  SliderFilledTrack,
  SliderProps,
  SliderThumb,
  SliderTrack,
} from '@chakra-ui/react'

interface SingleSliderProps extends SliderProps {}

// TODO add styles

const SingleSlider: React.FC<SingleSliderProps> = ({ ...props }) => {
  return (
    <Slider {...props}>
      <SliderTrack>
        <SliderFilledTrack />
      </SliderTrack>
      <SliderThumb />
    </Slider>
  )
}

export default SingleSlider
